import React,{Component} from 'react'
import { Steps, Button, message , Form , Modal, Spin, Row, Col} from 'antd';
import employeeStore from '../../../store/EmployeeStore';
import PersonalDetails from './PersonalDetails'
import ContactDetails from './ContactDetails';
import Verification from './Verification';
import UserAccount from './UserAccount';
import JobRole from './JobRole'


import axios from 'axios'
import keys from '../../../keys';
import { connect } from 'react-redux';


const { Step } = Steps;
const {confirm} = Modal;

class AddEmployeeWiz extends Component {
    state = {
            loading : false,
            current: 0,
            employee :{
                NIC : "",
                first_name:"",
                last_name:"",
                entity:"",
                EmployeeType:"",
                EmployeeTypeTitle:"",
                user:{
                    username:"",
                    password:""
                }
            },
            validity : {
                NIC : false
            }
        };

    

    addIdToState = (id,step) => {
       switch(step){
           case "useraccount":{
            this.setState(
                (prevState) => {
                  return  {
                        ...prevState,
                        employee:{
                            ...prevState.employee,
                            user: id
                        }
    
                    }
                }
            )
           }
           case "employment":{
            this.setState(
                (prevState) => {
                  return  {
                        ...prevState,
                        employee:{
                            ...prevState.employee,
                            EmployeeType: id,
                            EmployeeTypeTitle: id
                        }
    
                    }
                }
            ,()=>console.log(this.state))
           }
           case "employment_entity":{
            this.setState(
                (prevState) => {
                  return  {
                        ...prevState,
                        employee:{
                            ...prevState.employee,
                            entity: id
                        }
    
                    }
                }
            ,()=>console.log(this.state))
           }
           }
       }
       
     
   

    steps = [
        {
            title: 'Personal Details',       
            content:"Loading" ,
        },
        {
            title: 'Contact Details',
            content:  "Loading",
        },
        {
            title: 'Verifcation',
            content:  "Loading"
        },
        ];

    handleChange = (event)=> {
            event.preventDefault()
            console.log(this.props.form)
            const val = event.target.value

            switch(event.target.name){
                case "nic_input":{
                    this.setState(
                        (prevState)=>
                        {
                            return {
                                ...prevState,
                                employee:{
                                    ...prevState.employee,
                                    NIC: val
                                }
                            }
                        }
                        , ()=> console.log(this.state)
                    )
                    break;
                }
                case "first_name_input":{
                    this.setState(
                        (prevState)=>
                        {
                            return {
                                ...prevState,
                                employee:{
                                    ...prevState.employee,
                                    first_name:val
                                }
                            }    
                        }
                        , ()=> console.log(this.state)
                    )
                    break;
                }
                case "last_name_input":{
                    this.setState(
                        (prevState)=>
                        {
                            return {
                                ...prevState,
                                employee:{
                                    ...prevState.employee,
                                    last_name:val
                                }
                            }
                        }
                        , ()=> console.log(this.state)
                    )
                    break;
                }
                case "address_no_input":{
                    this.setState(
                        (prevState)=>
                        {
                            return {
                                ...prevState,
                                employee:{
                                    ...prevState.employee,
                                    address_no:val
                                }
                            }   
                        }
                        , ()=> console.log(this.state)
                    )
                    break;
                }
                case "address_street_input":{
                    this.setState(
                        (prevState)=>
                        {
                            return {
                                ...prevState,
                                employee:{
                                    ...prevState.employee,
                                    address_street:val

                                }
                            } 
                        }
                        , ()=> console.log(this.state)
                    )
                    break;
                }
                case "address_town_input":{
                    this.setState(
                        (prevState)=>
                        {
                            return {
                                ...prevState,
                                employee:{
                                    ...prevState.employee,
                                    address_town:val

                                }
                            }
                        }
                        ,()=> console.log(this.state)
                    )
                    break;
                }

                case "address_district_input":{
                    this.setState(
                        (prevState)=>
                        {
                            return {
                                ...prevState,
                                employee:{
                                    ...prevState.employee,
                                    address_district:val

                                }
                            }
                        }
                        , ()=> console.log(this.state)
                    )
                    break;
                }              
                case "contact_no_input":{
                    this.setState(
                        (prevState)=>
                        {
                            return {
                                ...prevState,
                                employee:{
                                    ...prevState.employee,
                                    contact_no:val
                                }
                            }       
                        }
                        , ()=> console.log(this.state)
                    )
                    break;
                }
                case "account_username_input":{
                    this.setState(
                        (prevState)=>
                        {
                            return {
                                ...prevState,
                                employee:{
                                    ...prevState.employee,
                                    user:{
                                        ...prevState.employee.user,
                                        username:val
                                    }
                                }
                            }       
                        }
                        , ()=> console.log(this.state)
                    )
                    break;
                }
                default:{
                  
                    break;
                }               
            }        
          }

   resetSteps(){

    this.steps = [
        {
          title: 'Personal Details',  
          content: <PersonalDetails {...this.state} handleChange={this.handleChange}/>
        },
        {
          title: 'Contact Details',
          content:  <ContactDetails {...this.state} handleChange={this.handleChange}/>
       
        },
        {
            title: "User Account",
            content: <UserAccount {...this.state} 
                            next={() => this.setState(prevState=>({current:prevState+1}))} 
                            addIdToState = {this.addIdToState}
                            handleChange={this.handleChange}
                    />
        }
        ,
        {
            title: 'Employement Details',
            content:  <JobRole addIdToState={this.addIdToState} handleChange={this.handleChange}/>
         
        },
        {
          title: 'Verifcation',
          content: <Verification {...this.state} handleChange={this.handleChange}/>          
        }
      ];
    
   }       


 
  
  next(e) {
    e.preventDefault();
    var nic_pat = /^([0-9]{9}[x|X|v|V]|[0-9]{12})$/
  //  var is_registered = employeeStore.getEmployeeByNIC(this.state.customer.NIC).pop() ? true : false
    // console.log(nic_pat.test(this.state.customer.NIC))          
    if(!nic_pat.test(this.state.employee.NIC)){
        message.error("Invalid National Identity Number")
        return false
    }

    // if(employeeStore.getEmployeeByNIC(this.state.employee.NIC).length > 0){

    //     message.error("Provided NIC already associated with another employee")
    //     return false
    // }

    this.props.form.validateFields((err, values) => {
      if (!err || false /*!is_registered*/){
        const current = this.state.current + 1;
        this.setState({ current });
      }
    });
  };
    
  

  prev() {
    const current = this.state.current - 1;
    this.setState({ current });
  }

  backToStart = () => {
    this.setState({
        loading : false,
        current: 0,
        employee :{
            NIC : "",
            first_name:"",
            last_name:"",
            entity:"",
            EmployeeType:"",
            user:{
                username:"",
                password:""
            }
        },
        validity : {
            NIC : false
        }
    },()=>console.log(this.state));
  }

//   showConfirm(props,state,backToStart) {
//     confirm({
//       title: 'Do you Want to create user ?',
//       content: 'You can directly go to add sale from here or add sale later on add sale section.',
//       onOk() {
//         console.log('OK');
//         props.history.push('/addsale/'+state.customer.NIC)
//       },
//       onCancel() {
//         console.log('Cancel');
//         backToStart()
//       },
//     });
 // }



  handleAdd=() =>
  {

    this.setState({
        loading:true
    })
    const {server} = this.props.entity 
    axios.post(`${server}/user/create-address/`, {
        "No":this.state.employee.address_no,
        "Street":this.state.employee.address_street,
        "Town":this.state.employee.address_town,
        "District":this.state.employee.address_district
    })
    .then(
        response => {
            if (response.statusText === "OK"){
                const address = response.data
                message.success("Address created successfuly")
                axios.post(`${server}/user/create-contact/v1`,{
                    "FirstName":this.state.employee.first_name,
                    "LastName": this.state.employee.last_name,
                    "ContactNo":this.state.employee.contact_no,
                    "Address" : address.id
                })
                .then(
                    response => {
                        console.log(response)
                        if (response.statusText === "Created"){
                            const contact = response.data
                            const data ={
                                "NIC":this.state.employee.NIC,
                                "Contact": contact.id,
                                "User":this.state.employee.user,
                                "EmployeeType": this.state.employee.EmployeeType,
                                "Entity": this.state.employee.entity}
                            console.log(data)
                            message.success("Contact created successfuly")
                            axios.post(`${server}/user/create-employee/`,data)
                            .then(
                              response =>{  
                                  console.log(response)
                                  if(response.statusText === "Created"){
                                    const employee = response.data
                                    message.success("Employee Created Successfuly")
                                    this.setState({loading:false},()=>console.log(this.state))
                                    this.backToStart()
                                } else{
                                    message.success("Employee creation failed")
                                }
                                }
                            )
                        }else{
                            message.error("Contact Creation failed")
                        }
                    }
                )
            }
            else{
                message.error("Creating address failed")   
            }
               
            }
    ).catch(
        (err) => {
            console.error(err)
        }
    )
}
    

  


  render() {
    
    this.resetSteps()
    const { current } = this.state;
    console.log(current)
    return (
        
         <Spin spinning={this.state.loading }>
        <div>
            <Steps  size="small" current={current}>
            {this.steps.map(item => (
                <Step key={item.title} title={item.title} />
            ))}
            </Steps>
            <Row>
                <Col offset={2} span={20}>
                    <div className="steps-content">         
                        {this.steps[current].content}             
                    </div>
                    <div className="steps-action">
                    {current < this.steps.length - 1 && (
                        <Button type="primary" onClick={(event) => this.next(event)}>
                        Next
                        </Button>
                    )}
                    {current === this.steps.length - 1 && (
                        <Button type="primary" onClick={this.handleAdd}>
                        Add
                        </Button>
                    )}
                    {current > 0 && (
                        <Button style={{ marginLeft: 8 }} onClick={() => this.prev()}>
                        Previous
                        </Button>
                    )}
                    </div>
                </Col>
            </Row>
        </div>
       
        </Spin>
    );
  }
}

const mapStateToProps = state => ({
    entity : state.entity
})



export default Form.create({ name: 'register' })(connect(mapStateToProps,null)(AddEmployeeWiz));